/**
 * Only these AWS accounts are recognized as valid sources of roles for ops-hub. Any role
 * returned by the Authorization API (AWS SSO device flow, see api/authorizationApi.ts) for a
 * different account is discarded -- this app has no concept of per-dataset/hub accounts like
 * cdh-data-portal-internal, so a role is either "ops-hub dev", "ops-hub prod", or not ours.
 */
export const ALLOWED_ACCOUNT_IDS = {
  dev: '266735843376',
  prod: '577638401079',
} as const

export type Environment = keyof typeof ALLOWED_ACCOUNT_IDS

export function environmentForAccountId(accountId: string): Environment | undefined {
  return (Object.keys(ALLOWED_ACCOUNT_IDS) as Environment[]).find(
    (environment) => ALLOWED_ACCOUNT_IDS[environment] === accountId,
  )
}

export function isAllowedAccountId(accountId: string): boolean {
  return environmentForAccountId(accountId) !== undefined
}
